import { Outlet } from "react-router-dom";

const RoutePublic = () => {
  return <Outlet />;
};

export default RoutePublic;
